const SET_CODEWORK_FILEPATH = 'codeworkFilepath/SET_CODEWORK_FILEPATH';

const initialState = null;

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_CODEWORK_FILEPATH:
        return action.codeworkFilepath;
    default:
        return state;
    }
};

const setCodeworkFilepath = filepath => ({
    type: SET_CODEWORK_FILEPATH,
    codeworkFilepath: filepath
});

export {
    reducer as default,
    initialState as codeworkFilepathInitialState,
    setCodeworkFilepath
};
